import manifest from '../../../public/release.json';

/**
 * The release this build belongs to, baked in at compile time.
 *
 * `public/release.json` is imported rather than fetched, so the number travels
 * inside the bundle: a running client always knows which release it IS, and can
 * compare that against the one the server is currently serving. Those two facts
 * are what separate "we deployed" from "there is something to tell people
 * about" — see `gate.ts`.
 */
export const BAKED_RELEASE: number = manifest.release;
